import {gql} from "@apollo/client";
import {Organization} from "@App/types";

export interface GarageDetailsQuery {
    Organization: Organization
}

export const GET_GARAGE_DETAILS = gql`
    query getGarageDetails(
        $id: ID,
        $organization:ID!) {
        organization(id: $organization) {
            id
            garages(
                id: $id
            ){
                data {
                    id
                    name
                    slug
                    profileSlug
                    phone
                    description
                    nationwide_service
                    rating
                    review_count
                    reviews {
                        distribution {
                            five
                            four
                            three
                            two
                            one
                        }
                        data {
                            id
                            author
                            comment
                            rating
                            cleanliness
                            quality
                            punctuality
                            competence
                            kindness
                            published_at
                            is_verified
                            vendor_name
                        }
                    }
                    street
                    city
                    postcode
                    supports_bev
                    services {
                        id
                        name
                        icon
                    }
                    baseCity {
                        name
                        slug
                        published_at
                    }
                    baseDistrict {
                        name
                    }
                    lat
                    lon
                    postcode
                    availableServices(organization_id: $organization) {
                        id
                        name
                        slug
                        icon
                    }
                    cover_image
                    cover_image_sizes {
                        name
                        path
                        media
                        width
                        height
                    }
                    images {
                        sizes {
                            name
                            path
                            media
                            width
                            height
                        }
                    }
                    opening_hours {
                        day
                        open
                    }
                    available_days {
                        id
                        available_at
                    }
                    checkpoint {
                        id
                        name
                        logo
                    }
                    garageConcept {
                        id
                        name
                        logo
                        description
                    }
                }
            }
        }
    }
`
